import React, { useCallback, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { cpf, cnpj } from 'cpf-cnpj-validator';

import { ContainerClients } from './style.js';
import { ActionSection, CardRow } from './components/CardStyles.js';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Menu from '../../../components/Menu/index.js';
import Footer from '../../../components/Footer/index.js';
import AuthGuard from '../../../components/AuthGuard/index.js';

import Container from 'react-bootstrap/Container';

import api from '../../../services/api.js';

import ButtonDefault from '../../../components/ButtonDefault/index.js';
import ModalAdd from '../../../components/Modals/ModalAdd/index.js';
import ModalDelete from '../../../components/Modals/ModalDelete/index.js';

import {
  ContractCard,
  StudyDataCard,
  SPCCard,
  ConsumptionUnitCard,
  CustomerCard,
  AddressCard,
  FilesCard,
  D4SignCard
} from './components';

const StudyEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  document.title = 'Enermerco - Editar Estudo';

  const [isSaving, setIsSaving] = useState(false);
  const [modalAddMeasure, setModalAddMeasure] = useState(false);
  const [modalDeleteFile, setModalDeleteFile] = useState(false);
  const [modalDeleteMeasure, setModalDeleteMeasure] = useState(false);
  const [idDeleteMeasure, setIdDeleteMeasure] = useState(0);
  const [idDm015, setIdDm015] = useState(0);
  const [idDm015Name, setIdDm015Name] = useState('');

  // Estados para armazenar dados dos componentes
  const [contractData, setContractData] = useState({});
  const [studyData, setStudyData] = useState({});
  const [spcData, setSpcData] = useState({});
  const [consumptionData, setConsumptionData] = useState({});
  const [customerData, setCustomerData] = useState({});
  const [addressData, setAddressData] = useState({});
  const [filesData, setFilesData] = useState([]);

  const validateCPFOrCNPJ = (value) => {
    const numericValue = value.replace(/\D/g, '');
    return cpf.isValid(numericValue) || cnpj.isValid(numericValue);
  };

  const handleSend = useCallback(async () => {
    console.log('SEND');
    setIsSaving(true);
    
    const dm014 = {
      ID_DM014: contractData.idDm014,
      IN_STATUS: contractData.inStatus,
      ID_DM013: contractData.idDm013,
      DT_VIGENCIA_DE: contractData.dtVigenciaDe,
      DT_VIGENCIA_ATE: contractData.dtVigenciaAte
    };

    const dm013 = {
      ID_DM013: contractData.idDm013,
      ID_DM011: consumptionData.idDm011,
      IN_TIPO_MEDICAO: studyData.inTipoMedicaoDm013,
      DT_ESTUDO: studyData.dtEstudoDm013,
      NR_ANOMES_DE: studyData.dtDeDm013,
      NR_ANOMES_ATE: studyData.dtAteDm013,
      JS_MEDICAO: studyData.inTipoMedicaoDm013 === '1' ? JSON.stringify(studyData.jsonMeasureDm013) : studyData.measureAvgDm013
    };

    const dm011 = {
      ID_DM011: consumptionData.idDm011,
      NR_UNIDADE_CONSUMO: consumptionData.nrUnidadeConsumo,
      NM_UNIDADE_CONSUMO: consumptionData.nmUnidadeConsumo,
      ID_DM003: consumptionData.idDm003,
      ID_DM006: consumptionData.idDm006,
      ID_DM009: consumptionData.idDm009,
      ID_DM012: consumptionData.idDm012,
      ID_DM001: consumptionData.idDm001,
      ID_DM002: addressData.idDm002Address,
      DS_ENDERECO: consumptionData.dsEndereco,
      NM_BAIRRO: consumptionData.nmBairro,
      NM_CIDADE: consumptionData.nmCidade,
      NR_CEP: consumptionData.nrCep,
      DS_COMPLEM_ENDERECO: consumptionData.dsComplemEndereco
    };

    const dm001 = {
      ID_DM001: customerData.idDm001,
      NM_CLIENTE: customerData.nmCliente,
      NM_FANTASIA: customerData.nmFantasia,
      NR_CPFCNPJ: customerData.nrCpfCnpj?.replaceAll('.', '').replaceAll('-', '').replaceAll('/', ''),
      NR_IE_RG: customerData.nrIeRg,
      DS_EMAIL: customerData.dsEmail,
      DS_EMAIL2: customerData.dsEmail2,
      NM_CONTATO: customerData.nmContato,
      IN_SITUACAO: customerData.inSituacao,
      IN_APROVADO: customerData.inAprovado,
      NR_FONE1: customerData.nrFone1,
      IN_WHATSAPP1: customerData.inWhatsapp1,
      NR_FONE2: customerData.nrFone2,
      IN_WHATSAPP2: customerData.inWhatsapp2,
      CD_CLIENTE: customerData.cdCliente,
      IN_ESTADO_CIVIL: customerData.inEstadoCivil,
      NM_PROFISSÃO: customerData.nmProfissao,
      DT_APROVADO: customerData.dtAprovado
    };

    const dm002 = {
      ID_DM001: customerData.idDm001,
      ID_DM002: addressData.idDm002Address,
      TP_ENDERECO: addressData.tpEnderecoAddress,
      NM_ENDERECO: addressData.nmEnderecoAddress,
      DS_LOGRADOURO: addressData.dsLogradouroAddress,
      NR_PREDIO: addressData.nrPredioAddress,
      NM_BAIRRO: addressData.nmBairroAddress,
      DS_COMPLEMENTO: addressData.dsComplementoAddress,
      NR_CEP: addressData.nrCepAddress,
      DS_REFERENCIA: addressData.dsReferenciaAddress,
      IN_PADRAO: addressData.inPadraoAddress,
      NM_CONTATO: addressData.nmContatoAddress,
      NM_UF: addressData.nmUfAddress,
      IN_SITUACAO: addressData.inSituacaoAddress,
      NM_CIDADE: addressData.nmCidadeAddress
    };

    const data = {
      dm014,
      dm013,
      dm011,
      dm001,
      dm002
    };

    if (!validateCPFOrCNPJ(customerData.nrCpfCnpj)) {
      toast.error('Informe um CPF ou CNPJ válido!');
      setIsSaving(false);
    } else {
      console.log('DATA', data);
      api
        .put('study', data)
        .then((response) => {
          if (response.status === 202) {
            toast.success('Estudo atualizado com sucesso!', {
              autoClose: 1500,
              onClose: () => {
                navigate('/study/list');
              }
            });
          } else {
            setIsSaving(false);
            toast.error(response.data.message);
          }
        })
        .catch((error) => {
          setIsSaving(false);
          console.log(error.response.data.error);
          toast.error(error.response.data.message);
        });
    }
  }, [contractData, studyData, consumptionData, customerData, addressData, navigate]);

  const handleModalOpen = (type, id, name) => {
    switch (type) {
      case 'addMeasure':
        setModalAddMeasure(true);
        break;
      case 'deleteMeasure':
        setIdDeleteMeasure(id);
        setModalDeleteMeasure(true);
        break;
      case 'deleteFile':
        setIdDm015(id);
        setIdDm015Name(name);
        setModalDeleteFile(true);
        break;
      default:
        break;
    }
  };

  const addMensalMeasure = (modalText, modalNumber1, modalNumber2) => {
    const json = [...(studyData.jsonMeasureDm013 || [])];
    const id = modalNumber1;
    const date = modalText;
    const measure = modalNumber2;

    const newItem = {
      date,
      id: parseInt(id),
      measure: parseFloat(measure)
    };
    
    const index = json.findIndex((item) => item.id === newItem.id);
    if (index !== -1) {
      json[index] = { ...json[index], ...newItem };
    } else {
      json.push(newItem);
    }
    json.sort((a, b) => a.id - b.id);
    
    const updatedStudyData = { ...studyData, jsonMeasureDm013: json };
    setStudyData(updatedStudyData);
    setModalAddMeasure(false);
  };

  const deleteFile = (idFile) => {
    setModalDeleteFile(false);
    api.delete(`files?id=${idFile}`).then((response) => {
      if (response.status === 200) {
        toast.success('Arquivo excluído com sucesso!');
        // Refresh files list
        const fetchFiles = async () => {
          const fileResponse = await api.get(`files?id=${id}`);
          if (fileResponse.status === 200) {
            setFilesData(fileResponse.data.data);
          }
        };
        fetchFiles();
      } else {
        toast.error('Erro ao excluir arquivo!');
      }
    }).catch(() => {
      toast.error('Erro ao excluir arquivo!');
    });
  };
  return (
    <>
      <AuthGuard />
      <Menu />
      <Container>
        <ContainerClients>
          <div className="page-header">
            <h2>Estudo #{id}</h2>
            <p>Edição dos dados do estudo de viabilidade técnica</p>
          </div>
          
          {/* Contrato e Estudo na mesma linha */}
          <CardRow>
            <Row>
              <Col lg={6} md={12}>
                <ContractCard 
                  studyId={id} 
                  onDataUpdate={setContractData}
                />
              </Col>
              <Col lg={6} md={12}>
                <StudyDataCard 
                  idDm013={contractData.idDm013} 
                  onDataUpdate={setStudyData}
                  onModalOpen={handleModalOpen}
                />
              </Col>
            </Row>
          </CardRow>
          
          {/* Cards menores na mesma linha */}
          <CardRow>
            <Row>
              <Col lg={6} md={12}>
                <SPCCard 
                  idDm013={contractData.idDm013} 
                  onDataUpdate={setSpcData}
                />
              </Col>
              <Col lg={6} md={12}>
                <FilesCard 
                  studyId={id} 
                  onDataUpdate={setFilesData}
                  onModalOpen={handleModalOpen}
                />
              </Col>
            </Row>
          </CardRow>
          
          {/* Card de Assinatura D4Sign */}
          <CardRow>
            <Row>
              <Col lg={12} md={12}>
                <D4SignCard 
                  idDm013={contractData.idDm013}
                  idDm014={contractData.idDm014}
                  studyStatus={contractData.inStatus}
                />
              </Col>
            </Row>
          </CardRow>
          
          {studyData.idDm011 && (
            <ConsumptionUnitCard 
              idDm011={studyData.idDm011} 
              onDataUpdate={setConsumptionData}
            />
          )}
          
          {/* Dados do Cliente em linha separada */}
          {consumptionData.idDm001 && (
            <CustomerCard 
              idDm001={consumptionData.idDm001} 
              onDataUpdate={setCustomerData}
            />
          )}
          
          {/* Dados do Endereço em linha separada */}
          {consumptionData.idDm001 && (
            <AddressCard 
              idDm001={consumptionData.idDm001} 
              onDataUpdate={setAddressData}
            />
          )}

          <ActionSection>
            <div className="btn-group">
              <ButtonDefault
                Width={'150px'}
                Margin={'0'}
                Text="Salvar"
                disabled={isSaving}
                onClick={() => {
                  handleSend();
                }}
              />
              <ButtonDefault
                Width={'150px'}
                Margin={'0'}
                Text="Cancelar"
                onClick={() => {
                  navigate('/study/list');
                }}
              />
            </div>
          </ActionSection>
        </ContainerClients>
        <ToastContainer />
      </Container>
      <Footer />
      
      <ModalAdd
        modalOpen={modalAddMeasure}
        handleClose={() => setModalAddMeasure(false)}
        handleConfirm={addMensalMeasure}
        handleCancel={() => setModalAddMeasure(false)}
        modalTitleText={'Adicionar nova Medição'}
        modalText={'Mês/Ano da Fatura'}
        visibleText={true}
        visibleNumber1={true}
        visibleNumber2={true}
        placeHolderText={'MM/AAAA'}
        textLabel={'Mês/Mês da Fatura'}
        number1Label={'Mês'}
        number2Label={'Medição kWh'}
        placeHolderNumber1={'Mês'}
        placeHolderNumber2={'kWh'}
      />
      
      <ModalDelete
        modalOpen={modalDeleteFile}
        handleClose={() => setModalDeleteFile(false)}
        handleConfirm={deleteFile}
        handleCancel={() => setModalDeleteFile(false)}
        modalTitleText={`Deseja excluir o arquivo #${idDm015}?`}
        modalText={idDm015Name}
        id={idDm015}
      />
      
      <ModalDelete
        modalOpen={modalDeleteMeasure}
        handleClose={() => setModalDeleteMeasure(false)}
        handleConfirm={() => {
          setModalDeleteMeasure(false);
          const updatedJson = studyData.jsonMeasureDm013?.filter((item) => item.id !== idDeleteMeasure) || [];
          updatedJson.sort((a, b) => a.id - b.id);
          const updatedStudyData = { ...studyData, jsonMeasureDm013: updatedJson };
          setStudyData(updatedStudyData);
        }}
        handleCancel={() => setModalDeleteMeasure(false)}
        modalTitleText={`Deseja excluir a medição #${idDeleteMeasure}?`}
        modalText={'Necessário salvar o estudo para efetivar a exclusão.'}
        id={idDeleteMeasure}
      />
    </>
  );
};

export default StudyEdit;
